import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _ from 'lodash';
import { useListFeedbacksQuery } from '~/types/types';
export default defineComponent({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: undefined
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['name'];
      }
    },
    defaultFilters: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var headers = computed(function () {
      return [{
        value: 'user.email'
      }, {
        value: 'title'
      }, {
        value: 'description'
      }, {
        value: 'url'
      }, {
        value: 'rating'
      }, {
        value: 'createdAt'
      }].filter(function (o) {
        var _props$columns;
        return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.includes(o.value);
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var filters = ref({});
    var variables = computed(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, props.defaultFilters), filters.value), {}, {
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      });
    });
    var _useListFeedbacksQuer = useListFeedbacksQuery(variables),
      result = _useListFeedbacksQuer.result,
      refetch = _useListFeedbacksQuer.refetch,
      loading = _useListFeedbacksQuer.loading;
    var items = computed(function () {
      var _result$value$listFee, _result$value;
      return (_result$value$listFee = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listFeedbacks) !== null && _result$value$listFee !== void 0 ? _result$value$listFee : [];
    });
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var selected = computed(function () {
      return items === null || items === void 0 ? void 0 : items.value.filter(function (logs) {
        return currentIds.value.filter(Boolean).includes(logs.id || '');
      });
    });
    var search = ref('');
    var onInput = function onInput(val) {
      var nextIds = val.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (_.isEqual(nextIds, currentIds.value)) {
        return;
      }
      emit('update:modelValue', nextIds);
      emit('input', nextIds);
    };
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countFeedbacks) || 0;
    });
    return {
      filters: filters,
      itemCount: itemCount,
      loading: loading,
      items: items,
      refetch: refetch,
      selected: selected,
      search: search,
      headers: headers,
      onInput: onInput,
      options: options
    };
  }
});